import statuses from '@/store/statuses';
import Services from '@/services/index';
import VuexTypes from '@/store/types/index';

const SyncAuditLogsService = Services.syncAuditLogs;
const SyncAuditLogsTypes = VuexTypes.syncAuditLogs;
export default {
  [SyncAuditLogsTypes.SYNC_AUDIT_LOGS_LIST]: ({ commit, state }, params) => {
    state.syncAuditLogsList['status'] = statuses.LOADING;
    SyncAuditLogsService.list(params).then((data) => {
      commit(SyncAuditLogsTypes.SYNC_AUDIT_LOGS_LIST, data);
    }).catch((errResponse) => {
      commit(SyncAuditLogsTypes.SYNC_AUDIT_LOGS_LIST, errResponse);
    });
  }
};
